import { Col, Row, Space, Table } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FrontierScenarioReportModel, RatingConfigurationModel } from "../../../../../models/scenario-frontier.model";
import { AMOUNT_UTIL } from "../../../../../utils/amount.utils";
import PercentInput from "../../../../atoms/percent-input";

const { Column, ColumnGroup } = Table;

interface Props {
    year: number;
    data: FrontierScenarioReportModel[];
    title: string;
    saveItem: (item: FrontierScenarioReportModel) => void;
    updateEditItems: (item: FrontierScenarioReportModel[]) => void;
}

const FrontierScenarioReport = (props: Props) => {

    const [data, setData] = useState<FrontierScenarioReportModel[]>([]);
    const { t } = useTranslation();
    const { year, saveItem } = props;
    const [editRows, setEditRows] = useState<FrontierScenarioReportModel[]>([]);

    const edit = (id: number) => {
        setEditRows(pre => {
            const item = data.find(x => x.id === id);
            if (item) {
                pre.push({ ...item });
            }
            return [...pre];
        });
    }

    const save = async (id: number) => {
        const item = data.find(x => x.id === id);
        if (item) {
            await saveItem(item);

            setEditRows(pre => {
                pre = pre.filter(x => x.id !== id);
                return [...pre];
            });
        }

    }

    const cancel = (id: number) => {

        setData(pre => {
            const item = editRows.find(x => x.id === id);
            const index = pre.findIndex(x => x.id === id);
            if (item) {
                pre[index] = item;
            }

            return [...pre]
        });

        setEditRows(pre => {
            pre = pre.filter(x => x.id !== id);
            return [...pre];
        });
    }

    const inputChange = (value: any, id: number, name: string) => {
        setData(pre => {
            const item: any = pre.find(x => x.id === id);
            if (item) {
                item[name] = value;
            }

            return [...pre]
        })
    }

    const renderYearCoulunm = (id: number, value: number, name: string) => {
        if (editRows.some(x => x.id === id)) {
            return <PercentInput onChange={(value) => inputChange(value, id, name)}
                value={value} />
        } else {
            return <> {AMOUNT_UTIL.converNumberToPercentage(value)}
            </>
        }

    }

    const renderAction = (id: number) => {

        if (editRows.some(x => x.id === id)) {
            return <>
                <span className="blue-text action-text" onClick={() => save(id)}>
                    {t("ScenarioFrontier.lbSave")}
                </span>
                <span className="blue-text action-text" onClick={() => cancel(id)}>
                    {t("ScenarioFrontier.lbCancel")}
                </span>
            </>
        } else {
            return <span className="blue-text action-text" onClick={() => edit(id)}>
                {t("ScenarioFrontier.lbEdit")}
            </span>
        }
    }

    useEffect(() => {
        if (editRows && data) {
            props.updateEditItems(data.filter(x => editRows.some(p => p.id === x.id)));
        }
    }, [data, editRows, props])

    useEffect(() => {
        setData(props.data);
    }, [props.data])

    return (
        <div className="variables-configuration">
            <h4>
                {props.title}
            </h4>

            <Row>
                <Col span={24}>

                    <Table
                        className="second-table"
                        bordered
                        pagination={false}
                        dataSource={data}
                        rowKey="id">
                        <Column dataIndex="name" key="name" />
                        <ColumnGroup title={t("ScenarioFrontier.lbBaseCase")}>
                            <Column align="right" title={year} dataIndex="base_next_year" key="base_next_year"
                                render={(value: number, record: any) => renderYearCoulunm(record.id, value, "base_next_year")} />
                            <Column align="right" title={year + 1} dataIndex="base_next_2_year" key="base_next_2_year"
                                render={(value: number, record: any) => renderYearCoulunm(record.id, value, "base_next_2_year")} />
                            <Column align="right" title={year + 2} dataIndex="base_next_3_year" key="base_next_3_year"
                                render={(value: number, record: any) => renderYearCoulunm(record.id, value, "base_next_3_year")} />
                        </ColumnGroup>
                        <ColumnGroup title={t("ScenarioFrontier.lbStressCase")}>
                            <Column align="right" title={year} dataIndex="stress_next_year" key="stress_next_year"
                                render={(value: number, record: any) => renderYearCoulunm(record.id, value, "stress_next_year")} />
                            <Column align="right" title={year + 1} dataIndex="stress_next_2_year" key="stress_next_2_year"
                                render={(value: number, record: any) => renderYearCoulunm(record.id, value, "stress_next_2_year")} />
                            <Column align="right" title={year + 2} dataIndex="stress_next_3_year" key="stress_next_3_year"
                                render={(value: number, record: any) => renderYearCoulunm(record.id, value, "stress_next_3_year")} />
                        </ColumnGroup>
                        <ColumnGroup title={t("ScenarioFrontier.lbReverseStressCase")}>
                            <Column align="right" title={year} dataIndex="reverse_stress_next_year" key="reverse_stress_next_year"
                                render={(value: number, record: any) => renderYearCoulunm(record.id, value, "reverse_stress_next_year")} />
                            <Column align="right" title={year + 1} dataIndex="reverse_stress_next_2_year" key="reverse_stress_next_2_year"
                                render={(value: number, record: any) => renderYearCoulunm(record.id, value, "reverse_stress_next_2_year")} />
                            <Column align="right" title={year + 2} dataIndex="reverse_stress_next_3_year" key="reverse_stress_next_3_year"
                                render={(value: number, record: any) => renderYearCoulunm(record.id, value, "reverse_stress_next_3_year")} />
                        </ColumnGroup>
                        <Column width={102} title="" key="actions" render={(text: string, record: RatingConfigurationModel) => <>
                            <Space>
                                {
                                    renderAction(record.id)
                                }
                            </Space>
                        </>} />
                    </Table>
                </Col>
            </Row>
        </div>
    )
}

export default FrontierScenarioReport;